import { useState } from 'react';
import z from 'zod';

import type { CallLog } from '@/models';
import { Authentication } from '@/rbac';
import PaginateCallLogs from '@/routes/arc/call-logs/PaginatedCallLogs.tsx';
import AdminStatisticsNav from '@/routes/arc/widgets/admin-statistics-nav/AdminStatisticsNav.tsx';

import CallLogEdit from './CallLogEdit.tsx';

export const Route = createFileRoute({
  component: AdminPage,
  validateSearch: z.object({
    current: z.number().int().optional(),
    pageSize: z.number().int().optional(),
  }),
});

function AdminPage() {
  const [selectedCallLog, setSelectedCallLog] = useState<CallLog | null>(null);
  const searchParams = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <>
      <div className={'flex min-h-0 flex-1 flex-col'}>
        <AdminStatisticsNav />
        <div className={'flex min-h-0 flex-1 flex-col p-2.5'}>
          <div className={'flex min-h-0 flex-1 gap-2.5'}>
            <div
              className={
                'arc-card flex min-h-0 flex-1 flex-col overflow-x-auto'
              }
            >
              <Authentication
                require={['arc:call-log:list']}
                failMode={'empty'}
              >
                <PaginateCallLogs
                  selected={selectedCallLog}
                  onSelect={setSelectedCallLog}
                  searchParams={{
                    current: searchParams.current ?? 1,
                    pageSize: searchParams.pageSize ?? 10,
                  }}
                  onPaginationChange={(current, pageSize) =>
                    navigate({
                      search: (old) => ({
                        ...old,
                        current,
                        pageSize,
                      }),
                    })
                  }
                />
              </Authentication>
            </div>
            {selectedCallLog && <CallLogEdit call={selectedCallLog} />}
          </div>
        </div>
      </div>
    </>
  );
}
